import React from 'react'
import OderTabs from '../components/odersection/OderTab'

export default function OrderPage() {
  return (
    <div>
      <OderTabs />
    </div>
  )
}
